/* global axios */
import ApiClient from '../ApiClient';

// T-118: grupos de contatos duplicados, merge assistido e descarte.
class DuplicadosAPI extends ApiClient {
  constructor() {
    super('fandata/duplicados', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  // Irreversível: um grupo por vez, com a base escolhida na tela.
  mesclar(baseId, mergeeIds) {
    return axios.post(`${this.url}/mesclar`, {
      base_id: baseId,
      mergee_ids: mergeeIds,
    });
  }

  ignorar(digests) {
    return axios.post(`${this.url}/ignorar`, { digests });
  }

  // Sem digests, devolve todos os descartados para a lista.
  reconsiderar(digests) {
    return axios.post(`${this.url}/reconsiderar`, { digests });
  }
}

export default new DuplicadosAPI();
